/** Keep the entire menu within the visible viewport, including narrow tablets. */
export function headerMenuBounds(viewportWidth: number, viewportHeight: number, headerBottom: number,
  triggerLeft: number, triggerRight: number, requestedWidth: number, alignRight = false, centered = false) {
  const gutter = Math.min(16, viewportWidth / 4);
  const width = Math.max(0, Math.min(requestedWidth, viewportWidth - gutter * 2));
  const preferred = centered ? (viewportWidth - width) / 2 : alignRight ? triggerRight - width : triggerLeft;
  const left = Math.max(gutter, Math.min(preferred, viewportWidth - width - gutter));
  const top = Math.max(0, Math.min(headerBottom, viewportHeight - gutter));
  return { left, top, width, maxHeight: Math.max(0, viewportHeight - top - gutter) };
}
